// All worlds in unlock order: one import line per world (folder src/worlds/<key>/).
// The import registers the world in the Registry (defineWorld), so the order here IS the unlock order.
// New world: create the folder and add one line here – see src/worlds/README.md.
import { Registry } from '../core/registry';
import '../kit';   // the core parts, machines and goals are registered before the worlds
import './breakfast';
import './dishes';
import './socks';
import './toothbrush';
import './cats';
import './henhouse';
import './moles';
import './penguins';
import './pizza';
import './spaghetti';
import './jelly';
import './space';
import './robot';
import './attic';
import './ocean';
import './upsidedown';

export const WORLDS = Registry.order.map(k => Registry.worlds[k]);
